import React from 'react';
import { JOKE_CATEGORIES } from '../../utils/jokesLibrary';

const JokesTab = ({ filteredJokes, jokeCategory, setJokeCategory, copyJokeToClip, copiedJokeId }) => (
  <div data-testid="jokes-tab">
    <div className="ocean-shimmer" style={{ background: '#475569', borderRadius: 12, padding: 16, border: '1px solid rgba(252, 211, 77,0.15)', position: 'relative', marginBottom: 16 }}>
      <div style={{ position: 'relative', zIndex: 4 }}>
        <h3 className="shimmer-text" style={{ margin: '0 0 4px', fontSize: '1.1rem' }}>
          <i className="fas fa-theater-masks" style={{ marginRight: 8, color: '#047857' }} />
          The Joke Vault
        </h3>
        <p style={{ color: '#71717a', fontSize: '0.72rem', margin: '0 0 10px' }}>
          Dry, witty, satirical humor inspired by "Letters to Evelyn" by John Selman.
          Click any joke to copy it. Share the laughter. Survive another day.
        </p>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {JOKE_CATEGORIES.map(jc => (
            <button key={jc.id} onClick={() => setJokeCategory(jc.id)}
              className={`filter-pill ${jokeCategory === jc.id ? 'filter-pill-active' : ''}`}
              style={{
                padding: '4px 10px', borderRadius: 6, fontSize: '0.68rem', cursor: 'pointer',
                background: jokeCategory === jc.id ? 'rgba(252, 211, 77,0.2)' : '#475569',
                border: jokeCategory === jc.id ? '1px solid rgba(252, 211, 77,0.4)' : '1px solid rgba(255,255,255,0.06)',
                color: jokeCategory === jc.id ? '#c4b5fd' : '#71717a'
              }} data-testid={`joke-cat-${jc.id}`}>
              <i className={`fas ${jc.icon}`} style={{ marginRight: 4, fontSize: '0.58rem' }} />
              {jc.label}
            </button>
          ))}
        </div>
      </div>
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 12 }}>
      {filteredJokes.map(joke => (
        <div key={joke.id} className="ocean-shimmer shimmer-border" data-testid={`joke-${joke.id}`}
          onClick={() => copyJokeToClip(joke)}
          style={{
            background: copiedJokeId === joke.id ? 'rgba(16,185,129,0.12)' : '#475569',
            borderRadius: 12, padding: 16, cursor: 'pointer', position: 'relative',
            border: copiedJokeId === joke.id ? '1px solid rgba(16,185,129,0.4)' : '1px solid rgba(252, 211, 77,0.12)',
            transition: 'all 0.3s ease', overflow: 'hidden'
          }}>
          <div style={{ position: 'relative', zIndex: 4 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
              <span style={{ background: 'rgba(252, 211, 77,0.15)', color: '#047857', padding: '2px 8px', borderRadius: 6, fontSize: '0.6rem', fontWeight: 600 }}>
                {joke.category}
              </span>
              <span style={{ color: copiedJokeId === joke.id ? '#10b981' : '#555', fontSize: '0.6rem' }}>
                {copiedJokeId === joke.id ? 'Copied!' : 'Click to copy'}
              </span>
            </div>
            <p style={{ color: '#334155', fontSize: '0.82rem', lineHeight: 1.6, margin: 0, fontStyle: 'italic' }}>
              "{joke.text}"
            </p>
            <div style={{ marginTop: 8, display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              {joke.tags.map(tag => (
                <span key={tag} style={{ background: 'rgba(253, 230, 138,0.08)', color: '#555', padding: '1px 6px', borderRadius: 4, fontSize: '0.52rem' }}>
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
    {filteredJokes.length === 0 && (
      <div style={{ color: '#555', textAlign: 'center', padding: 40, fontSize: '0.82rem' }}>
        No jokes match your filter. Try a different category.
      </div>
    )}
  </div>
);

export default JokesTab;
